import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdataAmat() {
	let obj = {
		formlist: [{
			prop: "name",
			label: "任务名称",
			type: "input",
			width: "220px"

		}, {
			prop: "type",
			label: "模板名称",
			type: "select",
			width: "220px",
			selectval: []

		}, ],
		searchlist: [{
			prop: "batchNo",
			label: '导入批次号',
			type: "input",
		}, {
			prop: "status",
			label: '批次状态',
			type: "select",
			selectval: comMapping.$scrwlx
		}],
		searchdata: {
			batchNo: '',
			status: '',
		},
		headData: [{
				title: "导入批次号",
				prop: "batchNo",
				width: "150",
				issort: true,
			}, {
				title: "任务类型",
				prop: "subType",
				width: "150",
				custom: true,
				issort: true,
			},
			{
				title: "批次状态",
				prop: "status",
				width: "150",
				custom: true,
				issort: true,
			},
			{
				title: "当前执行步骤",
				prop: "step",
				width: "150",
				issort: true,
			},
			{
				title: "任务名称",
				prop: "name",
				width: "150",
				issort: true,
			},
			{
				title: "文件名",
				prop: "fileName",
				width: "150",
				issort: true,
			},
			{
				title: "财年期间",
				prop: "cainianQijian",
				width: "150",
				issort: false,
			},
			{
				title: "导入开始时间",
				prop: "createTime",
				width: "150",
				issort: true,
			},
			{
				title: "导入结束时间",
				prop: "updateTime",
				width: "150",
				issort: true,
			},{
				title: "过账开始时间",
				prop: "postingStartTime",
				width: "150",
				issort: true,
			},
			{
				title: "过账结束时间",
				prop: "postingEndTime",
				width: "150",
				issort: true,
			}, {
				title: "操作人",
				prop: "creator",
				width: "150",
				issort: true,
			}, {
				title: "操作",
				prop: "cz",
				width: "250",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
